<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
          <div class="popup-title mr-auto" translate>lblAddRole</div>
          <div class="float-right">
            <a class="close mr-3" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
              </a>
          </div>
          
        </div>
        <form [formGroup]="addRoleForm" (ngSubmit)="AddRole()">
          <div class=" scrollbar">
            <div class="card-content">
              <div class="card-body p-0">
                <div class="form-row">
                  <div class="col-md-6 af-form-group">
                    <label for="roleName" translate>lblRoleName<strong class="mlt6 required"> * </strong> </label>
                    <div class="lbl-info">
                      <input formControlName="roleName" class="form-control mb-2" maxlength="39"
                      [ngClass]="{'is-invalid': cpf.roleName.invalid && cpf.roleName.touched}">
                      <div *ngIf="cpf.roleName.touched && (cpf.roleName.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                          lblRoleNameRequired
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 af-form-group">
                    <label for="service" translate>lblPriority<strong class="mlt6 required"> * </strong>
                       </label>
                    <div class='lbl-info'>
                      <input formControlName="priority" class="form-control mb-2" pattern="^[0-9]*$" maxlength="8"
                        (keypress)="isDigit($event)">
                      <div *ngIf="cpf.priority.touched && (cpf.priority.errors?.pattern)" class="help-block mt-1 text-danger"
                        translate>
                        lblOnlyNumbersAreAllowed
                      </div>
                      <div *ngIf="cpf.priority.touched && (cpf.priority.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                        lblPriorityRequired
                    </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6 af-form-group">
                      <label for="template-fueltype" translate>lblApplication<strong class="mlt6 required">
                          *</strong> </label>
                      <div class='lbl-info'>
                        <ng-select formControlName="applicationCode" placeholder="{{ 'lblSelectApplication' | translate }}"
                          required [ngClass]="{'ng-select-is-invalid':(cpf.applicationCode.invalid  && cpf.applicationCode.touched)}">
                          <ng-option *ngFor="let app of applicationMasterList" [value]="app.applicationCode">
                            {{app.applicationName}}</ng-option>
                        </ng-select>
                        <div *ngIf="(cpf.applicationCode.invalid && (cpf.applicationCode.dirty || cpf.applicationCode.touched))"
                          class="help-block text-danger">
                          <div *ngIf="cpf.applicationCode.errors.required"><span translate>lblApplicationRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" [disabled]="!addRoleForm.valid" translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
              </button>
              <a  (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>